import { useContext, useState } from "react";
import Layout from "../../Component/layout/main-layout";
import { useTranslation } from "react-i18next";
import Physical from "../../Component/online-service/electron-filing/physical";
import Juridical from "../../Component/online-service/electron-filing/juridical";
import AppProcedure from "../../Component/online-service/app_procedure";
import layoutBgImg from "../../Images/layout/onlineService.jpg";
import { Context } from "../../Store/context";
import GlobalLayout from "../../Component/layout/global-layout";
import { SendAppealRequest } from "../../api/Queries/post";
import {
    buildAppealFormData,
    getApiErrorMessage,
    validateAppealForm,
} from "../../Helper/appealFormHelpers";
import { useNavigate } from "react-router-dom";

const initialData = {
    requester_type: "",
    province: "",
    district: "",
    request_type: "",
    organization_name: "",
    first_name: "",
    last_name: "",
    patronimic: "",
    email: "",
    phone_number: "",
    attachment: null,
    message: "",
    address: "",
    position: "",
};

const ElectronFiling = () => {
    const { t } = useTranslation();

    const [formType, setFormType] = useState("physical");
    const [modalOpen, setModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(initialData);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const { showError, showSuccess } = useContext(Context);

    const clearError = (field) => {
        setErrors((prev) => ({
            ...prev,
            [field]: "",
        }));
    };

    const handlePost = async (requesterType) => {
        const validation = validateAppealForm({
            data,
            requesterType,
            t,
        });

        setErrors(validation);

        if (Object.keys(validation).length > 0) {
            return;
        }

        const payload = {
            ...data,
            requester_type: requesterType,
        };

        setIsLoading(true);

        try {
            const formData = buildAppealFormData(payload);
            await SendAppealRequest(formData);
            showSuccess(t("appeal_success"));
            setData(initialData);
            setErrors({});
            navigate("/");
        } catch (error) {
            showError(getApiErrorMessage(error, t));
        } finally {
            setIsLoading(false);
        }
    };

    const handleChangeFormType = (type) => {
        setFormType(type);
        setData(initialData);
        setErrors({});
    };

    return (
        <GlobalLayout
            title={`${t("online_appeals")} - ${t("supreme_court")} ${t("turkmenistan")}`}
            keywords="Onlaýn ýüztutmalar, Onlayn yuztutmalar, Online yuztutmalar,
                Online appeals, Онлайн oбращения, Обращения, Ýüztutmalar, 
                Yuztutmalar, Kazyyete yuztutma"
        >
            <div className="mb-20">
                <Layout title={t("online_appeals")} layoutBgImg={layoutBgImg} />

                <main className="media">
                    <section
                        className="mt-8 lg:p-8 p-4 bg-white
                       dark:bg-dark-box"
                    >
                        <div className="relative text-center">
                            <h1
                                className="font-bold text-2xl lg:text-4xl text-center 
                           text-primary dark:text-dark-text"
                            >
                                {t("online_appeals")}
                            </h1>

                            <button
                                type="button"
                                className="bg-primary text-white px-4 py-2 
                           rounded lg:absolute right-0 top-0
                           mt-4 lg:mt-0"
                                onClick={() => setModalOpen(true)}
                            >
                                {t("application_procedure")}
                            </button>

                            <AppProcedure
                                isOpen={modalOpen}
                                onClose={() => setModalOpen(false)}
                            />
                        </div>

                        <div className="my-10 flex space-x-2 justify-between lg:justify-start w-full">
                            <button
                                type="button"
                                className={`px-4 py-2 rounded-md font-semibold w-[50%] lg:w-max
                            ${formType === "physical"
                                        ? "bg-primary text-white"
                                        : "bg-secondary text-black"
                                    }`}
                                onClick={() => handleChangeFormType("physical")}
                            >
                                {t("physical")}
                            </button>

                            <button
                                type="button"
                                className={`px-4 py-2 rounded-md font-semibold w-[50%] lg:w-max
                            ${formType === "juridic"
                                        ? "bg-primary text-white"
                                        : "bg-secondary text-black"
                                    }`}
                                onClick={() => handleChangeFormType("juridic")}
                            >
                                {t("juridical")}
                            </button>
                        </div>

                        {formType === "physical" && (
                            <Physical
                                data={data}
                                setData={setData}
                                handlePost={handlePost}
                                isLoading={isLoading}
                                errors={errors}
                                clearError={clearError}
                            />
                        )}

                        {formType === "juridic" && (
                            <Juridical
                                data={data}
                                setData={setData}
                                handlePost={handlePost}
                                isLoading={isLoading}
                                errors={errors}
                                clearError={clearError}
                            />
                        )}
                    </section>
                </main>
            </div>
        </GlobalLayout>
    );
};

export default ElectronFiling;